import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export default function CommercialTrendsPage() {
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState('');
    const [location, setLocation] = useState('');
    const [searched, setSearched] = useState(false);

    const data = {
        labels: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
        datasets: [
            {
                label: 'Recherches Clients',
                data: [1200, 1350, 1400, 1600, 1800, 1840, 1900, 1850, 2100, 2300, 2400, 2600],
                borderColor: '#3b82f6',
                backgroundColor: 'rgba(59, 130, 246, 0.2)',
                tension: 0.4,
                fill: true,
                pointRadius: 6,
                pointHoverRadius: 10
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: 'rgba(0,0,0,0.8)',
                padding: 15,
                titleFont: { size: 14 },
                bodyFont: { size: 16, weight: 'bold' },
                displayColors: false,
                callbacks: { label: (c) => `👥 ${c.raw} clients potentiels` }
            }
        },
        scales: {
            x: { grid: { display: false }, ticks: { color: 'rgba(255,255,255,0.5)' } },
            y: { grid: { color: 'rgba(255,255,255,0.1)' }, ticks: { color: 'rgba(255,255,255,0.5)' }, beginAtZero: true }
        }
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
                <h1 style={{ fontSize: '2rem', fontWeight: 800, display: 'flex', alignItems: 'center', gap: 10, margin: 0 }}>📈 Trends Local</h1>
                <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'rgba(255,255,255,0.1)', padding: '10px 20px', borderRadius: 50, border: 'none', color: 'white', cursor: 'pointer' }}>Fermer</button>
            </div>

            <div style={{ display: 'flex', gap: 20, marginBottom: 40 }}>
                <input
                    type="text" placeholder="Métier (Ex: Plombier)" value={keyword} onChange={e => setKeyword(e.target.value)}
                    style={{ flex: 1, padding: 20, borderRadius: 12, border: 'none', fontSize: '1.2rem', background: '#1e293b', color: 'white' }}
                />
                <input
                    type="text" placeholder="Ville (Ex: Bordeaux)" value={location} onChange={e => setLocation(e.target.value)}
                    style={{ flex: 1, padding: 20, borderRadius: 12, border: 'none', fontSize: '1.2rem', background: '#1e293b', color: 'white' }}
                />
                <button
                    onClick={() => setSearched(true)}
                    style={{ padding: '0 40px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 12, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
                >
                    🚀
                </button>
            </div>

            {searched && (
                <div style={{ flex: 1, display: 'flex', gap: 40 }}>
                    <div style={{ flex: 2, background: 'rgba(255,255,255,0.05)', borderRadius: 24, padding: 30, border: '1px solid rgba(255,255,255,0.1)' }}>
                        <Line data={data} options={options} height={100} />
                    </div>

                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 20 }}>
                        <div className="stat-card" style={{ background: '#22c55e', color: 'white' }}>
                            <div style={{ fontSize: '0.9rem', opacity: 0.8, textTransform: 'uppercase', marginBottom: 5 }}>Volume Mensuel</div>
                            <div style={{ fontSize: '3rem', fontWeight: 900 }}>2 600</div>
                            <div style={{ fontSize: '0.9rem' }}>Recherches actives</div>
                        </div>
                        <div className="stat-card" style={{ background: '#1e293b', border: '1px solid rgba(255,255,255,0.1)' }}>
                            <div style={{ fontSize: '0.9rem', opacity: 0.6, textTransform: 'uppercase', marginBottom: 5 }}>Tendance Annuelle</div>
                            <div style={{ fontSize: '3rem', fontWeight: 900, color: '#3b82f6' }}>+110%</div>
                            <div style={{ fontSize: '0.9rem', opacity: 0.6 }}>Croissance explosive</div>
                        </div>
                        <div className="stat-card" style={{ background: '#f59e0b', color: 'black' }}>
                            <div style={{ fontSize: '0.9rem', opacity: 0.8, textTransform: 'uppercase', marginBottom: 5 }}>Potentiel Perdu</div>
                            <div style={{ fontSize: '3rem', fontWeight: 900 }}>85%</div>
                            <div style={{ fontSize: '0.9rem' }}>Des clients vont chez les concurrents</div>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                .stat-card { padding: 30px; borderRadius: 24px; flex: 1; display: flex; flexDirection: column; justify-content: center; }
            `}</style>
        </div>
    );
}
